import * as React from 'react';
import type { SVGProps } from 'react';

const IconLike = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" {...props}>
    <path
      fill="currentColor"
      d="M7.493 13.025c-.463-.405-.912-.81-1.375-1.2-1.083-.911-2.176-1.811-3.258-2.725C1.097 7.612-.203 5.721.026 3.39.15 2.142.75 1.164 1.896.533c1.588-.874 3.523-.6 4.836.668.258.25.465.546.694.821.021.026.039.054.066.092l.067-.096c.554-.82 1.28-1.446 2.26-1.774 1.696-.57 3.736.02 4.677 1.653.672 1.166.606 2.591.187 3.824-.469 1.38-1.389 2.405-2.514 3.354-.246.208-.497.412-.746.618-1.31 1.085-2.629 2.158-3.886 3.298-.013.011-.027.02-.043.034Z"
    />
  </svg>
);
export default IconLike;
